import {
  generateDeepObjectParameter,
  generateDeepObjectParameterAsURLSearchParams,
  generateFormParamter,
  generateFormParamterAsURLSearchParams,
  generatePipeDelimitedParameter,
  generatePipeDelimitedParameterAsURLSearchParams,
  generateSpaceDelimited,
  generateSpaceDelimitedAsURLSearchParams
} from "./chunk-FTKOE5C2.js";
import {
  __export
} from "./chunk-GX7V4YTP.js";

// src/QueryParameter.ts
var QueryParameter_exports = {};
__export(QueryParameter_exports, {
  generate: () => generate,
  generateByURLSearchParams: () => generateByURLSearchParams
});
var generate = (key, params) => {
  if (params.style === "form") {
    return generateFormParamter(key, params);
  }
  if (params.style === "spaceDelimited") {
    return generateSpaceDelimited(key, params);
  }
  if (params.style === "pipeDelimited") {
    return generatePipeDelimitedParameter(key, params);
  }
  if (params.style === "deepObject") {
    return generateDeepObjectParameter(key, params);
  }
  return void 0;
};
var generateByURLSearchParams = (key, params) => {
  if (params.style === "form") {
    return generateFormParamterAsURLSearchParams(key, params);
  }
  if (params.style === "spaceDelimited") {
    return generateSpaceDelimitedAsURLSearchParams(key, params);
  }
  if (params.style === "pipeDelimited") {
    return generatePipeDelimitedParameterAsURLSearchParams(key, params);
  }
  if (params.style === "deepObject") {
    return generateDeepObjectParameterAsURLSearchParams(key, params);
  }
  return void 0;
};

export {
  generate,
  generateByURLSearchParams,
  QueryParameter_exports
};
//# sourceMappingURL=chunk-32ARFJZ4.js.map